__turbopack_context__.v({
  "activeQuestion": "faq-module-scss-module__KWBWwa__activeQuestion",
  "answer": "faq-module-scss-module__KWBWwa__answer",
  "openAnswer": "faq-module-scss-module__KWBWwa__openAnswer",
  "question": "faq-module-scss-module__KWBWwa__question",
  "root": "faq-module-scss-module__KWBWwa__root",
});
